/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicMetricsUtilization extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicMetricsUtilization");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicMetricsUtilization.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicMetricsUtilization>): BackgroundJobPayloadForPeriodicMetricsUtilization {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicMetricsUtilization(), model);
        BackgroundJobPayloadForPeriodicMetricsUtilization.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicMetricsUtilization>): BackgroundJobPayloadForPeriodicMetricsUtilization {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicMetricsUtilization.newInstance(<BackgroundJobPayloadForPeriodicMetricsUtilization> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicMetricsUtilization) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicMetricsUtilization.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicMetricsUtilization): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicMetricsUtilization.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
